// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"33":"d9917bed","41":"c77c6075","227":"38042235","254":"e95c6b89","306":"d3cb2778","399":"b9220c2b","560":"93d21516","680":"676a0297","701":"e0a9a828","725":"6fb786ab","811":"b0333ee7","958":"2e745344"}[chunkId] + ".js";
};